/* eslint-disable react/jsx-key */
/* eslint-disable no-irregular-whitespace */
import styles from 'components/cases/common/Interview/Interview.module.scss'
import TitleFlex from 'components/cases/common/TitleFlex'
import { useEffect, useRef } from 'react'
import { gsap, Power4 } from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
import { ContentData } from 'components/cases/common/Interview/fragments/type'
import InterviewContents from 'components/cases/common/Interview/InterviewContents'
gsap.registerPlugin(ScrollTrigger)

const sectionTitle: { title: string; sub_title: string } = {
  title: 'Interview',
  sub_title: 'インタビュー',
}

const contentData: ContentData[][] = [
  [
    {
      type: 'sectionTitle',
      text: '“移動”で日本の地域課題解決を目指す「meemo」プロジェクト',
    },
    {
      type: 'imageWithCaption',
      src: '/images/img/cases/meemo/interview1.webp',
      alt: 'インタビュー写真',
      text: 'プロジェクト全体の責任者として、サービス開発、事業計画、現場対応等を中心に手掛ける横田美希さん',
    },
    {
      type: 'greyBox',
      name: '横田さん',
      texts: [
        <>
          <p>
            もともとOSSでは2030年に向けて社会的課題を解決するためのプロジェクトを検討しており、その中で目をつけていたのが
            <span className={styles.red_text}>地域創生と交通課題</span>
            でした。
          </p>
          <p>
            2025年には地方交通事業者のドライバーが6割減少してしまうという試算があり、このままでは地方の交通が成り立たなくなってしまうと言われています。また、地元の住民の方々は自由に移動ができなくなり、友達にも会えなくなります。
          </p>
        </>,
        'そこで、我々は、住民が自治体や交通事業者に頼るだけでなく、自らサービスを作る側となってお互いに助け合うことができ、かつ、そのサービスを交通事業者と協業しながら実施することができれば、より持続的な地方の運営ができると考えました。',
      ],
    },
    {
      type: 'textBox',
      texts: [
        'そこで生まれたのが、住民同士による送迎、バス、タクシーといった多様な移動手段を網羅した「meemo」のコンセプト。',
        '送迎を必要とする住民と、登録ドライバーである住民をマッチングすることで、バスやタクシーの利用が難しい地域でもスムーズな移動を可能にする点が「meemo」最大の特徴です。',
      ],
      wide: false,
      bold: false,
    },
    {
      type: 'imageWithCaption',
      src: '/images/img/cases/meemo/interview2.webp',
      size: 'm',
      alt: 'インタビュー写真',
      text: (
        <p className={`${styles.img_text} ${styles.img_text__right} ${styles.img_text__m}`}>
          【出典：
          <a href="https://meemo.jp/#about" rel="noopener noreferrer" target="_blank">
            https://meemo.jp/#about
          </a>
          】
        </p>
      ),
    },
    {
      type: 'textBox',
      texts: [
        'そんな「meemo」プロジェクトが実行に移されたのは2018年10月ごろ。偶然が重なり、早期のスタートが実現しました。',
      ],
      wide: false,
      bold: false,
    },
    {
      type: 'greyBox',
      name: '横田さん',
      texts: [
        '「meemo」の企画を考えていた頃、タイミングよく京都府の舞鶴市副市長から彼らが抱える社会的課題をオムロンの技術で解決できないかとお問い合わせをいただいたのです。',
        'そうして市長を交えたプロジェクトを若手中心に組み、包括連携を結んで実証実験を始めることになりました。',
      ],
    },
  ],
  [
    {
      type: 'sectionTitle',
      text: '実証実験は好評。しかしアプリ開発に課題あり',
    },
    {
      type: 'textBox',
      texts: [
        '「meemo」の実証実験は、2020年7〜9月の約3ヶ月間にわたり舞鶴市の加佐・西地域にて実施。実験に参加したのは、40名の認定ドライバーと51名の利用者の合計91名。',
        '期間中、ドライバーと利用者による送迎は全111回マッチングが成立し、利用者の4分の3以上が「住民送迎に不安を感じなかった」と回答するなど好評を得る結果となりました。',
        'しかし、その一方で「meemo」アプリについては、利用者とドライバーからは完成度の低さを指摘する不満の声が多数寄せられてしまう結果ともなってしまいました。',
      ],
      wide: false,
      bold: false,
    },
    {
      type: 'imageWithCaption',
      src: '/images/img/cases/meemo/interview3.webp',
      alt: 'インタビュー写真',
      text: '顧客SEとしてユーザーへのシステム解説、実証実験を通して得た要望検討、その他の調整等を担当している平井佐和さん',
    },
    {
      type: 'greyBox',
      name: '平井さん',
      texts: [
        <>
          <p>
            <span className={styles.red_text}>当初、アプリの開発方針を『若い人も高齢者も使えるように』</span>
            としていたのですが、これがどっち付かずの結果につながってしまいました。結果としてメインターゲットである高齢者にとって使いづらいものになってしまい、『文字が読みにくい』との声が聞かれたほか、文字入力でつまずいてしまうケースが多く見られました。
          </p>
          <p>
            高齢者の方にスマホ操作を習得してもらうためにスマホ教室を開いたのですが、参加者が長い時間をかけて3文字打ったところで、指が違うボタンに当たって全部削除されてしまうのを3回繰り返す場面を目の当たりにして、スマホを使い慣れていない高齢者にとってはスマホの文字入力の難易度が高いことを痛感しました。
          </p>
          <p>
            そこで
            <span className={styles.red_text}>今回の改修では高齢者の方が使いやすいアプリを目指すことにしました。</span>
          </p>
        </>,
      ],
    },
    {
      type: 'imageWithCaption',
      src: '/images/img/cases/meemo/interview4.webp',
      alt: 'インタビュー写真',
      text: 'アプリの開発リーダーを務める久米田晴香さん',
    },
    {
      type: 'greyBox',
      name: '久米田さん',
      texts: [
        <>
          <p>
            昨年の実証実験では、もともとあまりアプリ開発経験のない会社にお願いしていたこともあり、改修にあたって新規パートナーを探すことになりました。
          </p>
          <p>
            実際に面談させていただいた企業数社の中でも、アイスリーさんは銀行など
            <span className={styles.red_text}>
              硬めの企業の案件実績も多数あり、高セキュリティルームも持たれていたので、自治体と企業が連携している「meemo」プロジェクトの特性を理解していただけるだろう
            </span>
            と最初から好印象を抱いていました。
          </p>
          <p>
            しかし、今回の改修にあたって別のデザイン会社様にデザインをお願いしていたことから、当初はお断りされてしまいました。
          </p>
        </>,
      ],
    },
    {
      type: 'textBox',
      texts: [
        '多数の開発実績、そしてUX/UIデザインに対する知見をもとに、デザインから開発までを一気通貫してプロジェクトに取り組めるのがAitriaの強みです。そのため当初、「meemo」の開発部分だけを請け負うのでは弊社のバリューを発揮できないと判断し、お断りさせていただきました。',
      ],
      wide: false,
      bold: false,
    },
    {
      type: 'textBox',
      texts: [
        'しかし、Aitriaの営業担当が「meemo」に非常に可能性を感じており、今後日本が直面する超高齢化社会に対して取り組む「meemo」に弊社の技術で寄与したいと強く考えたことで会社を説得。デザインや要求仕様がある程度固まっている中でも、AitriaのクラウドネイティブかつCI/CD（継続開発/継続デリバリ）を高速に提供できる開発手法で少なからずご協力ができると考えを改め、開発を請け負わせていただくこととなりました。',
      ],
      wide: false,
      bold: false,
    },
  ],
  [
    {
      type: 'sectionTitle',
      text: '開発力とデザイン力、その相乗効果が発揮された開発フェーズ',
    },
    {
      type: 'textBox',
      texts: [
        '紆余曲折を経て開発がスタートすることになった「meemo」改修ですが、実際には開発を始める前に約2ヶ月かけてデザインの手直しがAitriaで行われることになりました。',
      ],
      wide: false,
      bold: false,
    },
    {
      type: 'textBox',
      texts: [
        'その理由は、当初のデザイン案が開発を前提とした作りになっていなかったことが判明したからでした。例えば、モバイルアプリのデザインでは、電波の不安定な状況でのエラー表示をはじめとした「異常系」と呼ばれる画面表示や遷移が必要となります。さらには文字入力の際に、入力文字数が予想以上に多かった際などどのようにUI上で対応するかといった、多岐にわたるイレギュラー事象の想定が必要となります。元デザインではこうした考慮が不足していたこともあり、Aitria側で追加・調整することとなりました。',
      ],
      wide: false,
      bold: false,
    },
    {
      type: 'greyBox',
      name: '横田さん',
      texts: [
        '私たち企画側は、モバイルアプリ開発の経験が浅く、「meemo」プロジェクトの開発メンバーも若手が多かったということもあり、モバイルアプリ特有のデザインについて多くの気付きがありました。',
      ],
    },
    {
      type: 'imageWithCaption',
      src: '/images/img/cases/meemo/interview5.webp',
      alt: 'インタビュー写真',
      text: (
        <p className={styles.img_text} style={{ textAlign: 'center' }}>
          異常系画像（イメージ画像）
        </p>
      ),
    },
    {
      type: 'textBox',
      texts: [
        'そして、このデザイン見直しが当初の全体スケジュールを圧迫することとなります。実際に開発可能なデザインに落とし込むための調整が多岐にわたった結果、ローンチまでの開発期間が大きく圧縮されてしまったのです。',
      ],
      wide: false,
      bold: false,
    },
    {
      type: 'greyBox',
      name: '久米田さん',
      texts: [
        <p>
          しかし、時間がない中でも10月のリリース目標に寄り添っていただくことができました。場合によっては「こんなにデザインで調整が発生したのは御社の責任ですよね」と言われてもおかしくないですし、実際にこうした理由でローンチに間に合わなかった経験も過去たくさんありました。そのため、アイスリーさんには最後まで一生懸命ご対応いただき、なおかつ当初計画にしっかり間に合わせていただいたことに本当に感謝しております。また、最後に
          <span className={styles.red_text}>
            プッシュ通知の問題もあったことから、当初サーバーサイドの開発は頼む予定ではありませんでしたが、サーバーサイドの開発もできるアイスリーさんにお願いして本当によかった
          </span>
          と改めて実感しました。
        </p>,
      ],
    },
    {
      type: 'textBox',
      texts: [
        'そう、リリース直前にプッシュ配信サーバーの開発が間に合わないというトラブルが発覚してしまったのです。「meemo」は通常のアプリ以上に、プッシュ通知の重要度が高く、通知機能なしにはリリースできません。',
      ],
      wide: false,
      bold: false,
    },
    {
      type: 'greyBox',
      name: '久米田さん',
      texts: [
        <p>
          「meemo」は「Uber」のようにお金を稼ぎたいドライバーが常にスマホを見ているアプリとは違い、例えばですが認定ドライバーさんは農作業をしている最中でも利用者の依頼に気付けなければいけません。そのため
          <span className={styles.red_text}>
            通常のアプリの通知と違い、まるで電話の着信のように長いプッシュ通知を開発して実装する必要がありました。
          </span>
          プロジェクトチーム内でも「プッシュ通知なしにはリリースできない」という声が多かったことから、最後に間に合わせていただけて本当に助かりました。
        </p>,
      ],
    },
    {
      type: 'imageWithCaption',
      src: '/images/img/cases/meemo/interview6.webp',
      alt: 'インタビュー写真',
      text: (
        <p className={styles.img_text} style={{ textAlign: 'center' }}>
          プッシュ通知画面（イメージ画像）
        </p>
      ),
    },
  ],
  [
    {
      type: 'sectionTitle',
      text: 'PMF（プロダクト マーケットフィット）フェーズで長く愛されるアプリへ',
    },
    {
      type: 'textBox',
      texts: [
        'こうして「meemo」はデザインの見直しなど、多くの困難を乗り越え、無事スケジュール通りにリリースされました。この改修版を使った2021年の実証実験では、利用者の皆さまから多くの好評の声をいただくことができたそうです。',
      ],
      wide: false,
      bold: false,
    },
    {
      type: 'greyBox',
      name: '横田さん',
      texts: [
        <p>
          昨年は途中で離脱してしまった利用者の方も
          <span className={styles.red_text}>「文字入力が無くなって、地図で行き先を選べるから、これなら使えるよ」</span>
          と言ってくれたんです。これには本当に良かったと思いました。またドライバーさんからも「ドライバーアプリの方も使いやすくなったよ」とお褒めの言葉をいただけました。その一方で「これで満足しないでね」とも言われてはいますが（笑）。
        </p>,
      ],
    },
    {
      type: 'greyBox',
      name: '久米田さん',
      texts: [
        <p>
          <span className={styles.red_text}>リリース後も、毎週のようにバージョンアップを重ねています。</span>
          諸般の事情から期日でのリリースを優先に進めていたことから、修正すべき点がまだまだあるのですが、現在もアイスリーさんに素早く対応いただいており感謝しています。
        </p>,
      ],
    },
    {
      type: 'textBox',
      texts: [
        'Aitriaの特徴の一つに、リリースした時点で終わるのではなく、リリース後も継続して開発支援できる体制を提供できるという点があります。',
        'そのため毎週のようにデプロイしてローンチするという、大手SIer企業では難しい「スピード感」を実現できているのです。',
      ],
      wide: false,
      bold: false,
    },
    {
      type: 'greyBox',
      name: '山本',
      texts: [
        <p>
          Aitriaは、社会課題の解決に寄与することをミッションとしています。今回そのようなプロジェクトに関わらせていただけて非常に感謝しております。しかし、私個人としてはまだまだ「meemo」のUX/UIは改善できると感じており、アプリの現状に決して満足していません。さらに末長く使っていただくアプリを実現するためには、
          <span className={styles.red_text}>常にユーザーさんの声に耳を傾け、PMFしていくグロースフェーズが重要</span>
          です。今後も「meemo」の改善に携わらせていただければと考えています。
        </p>,
      ],
    },
    {
      type: 'greyBox',
      name: '久米田さん',
      texts: [
        <p>
          当初開発を断られてしまったことを忘れるくらい、アイスリーさんは
          <span className={styles.red_text}>親身に私たちの課題に寄り添ってデザインの見直しから開発まで</span>
          快く請け負ってくださいました。また、弊社のエンジニアは券売機や改札機、信号機などデバイスへの組み込み開発を中心に行なっていますが、今後社会インフラを作っていくためにはスマホUIが世の中との媒介になると考えております。そのため今回の「meemo」開発は、弊社としても非常に勉強をさせていただいたプロジェクトとなりました。
        </p>,
      ],
    },
    {
      type: 'textBox',
      texts: [
        '今後も「meemo」はさらなる改善を続けながら、日本の地域課題解決を通して、地方創生に寄与すべく展開していく予定です。',
      ],
      wide: false,
      bold: false,
    },
    {
      type: 'greyBox',
      name: '横田さん',
      texts: [
        '2021年12月で実証実験は終わりますが、プロジェクトは継続予定です。また今後は「meemo」を舞鶴市のみならず他の自治体様にも横展開すべく、その方法やエリアを模索しているところです。引き続きよろしくお願いいたします。',
      ],
    },
  ],
  [
    {
      type: 'sectionTitle',
      text: '担当者からのコメント',
    },
    {
      type: 'textBox',
      texts: [
        <p>
          Aitriaはデザインから開発までを一気通貫した、デザインとエンジニアリングの融合を強みとする企業ですが、今回の「meemo」改修においては当初開発のみを請け負う予定でした。しかし、実際にはアプリ開発の知見を活かし、“開発に即したデザイン”への見直しからプロジェクトに携わらせていただく結果となりました。今後はPMFのための修正を高速で繰り返しながら、より根本から
          <a href="https://aitria.co.jp/services/studio/uxui-improvement/" rel="noopener" target="_blank">
            UX/UI
          </a>
          のブラッシュアップにご協力させていただければと考えています。
        </p>,
      ],
      wide: false,
      bold: false,
    },
  ],
]

const tweenVars: gsap.TimelineVars = {
  y: 50,
  duration: 1,
  opacity: 0,
  ease: Power4.easeOut,
}

const Interview: React.FC = () => {
  const timeline = gsap.timeline()
  const wrapper = useRef<HTMLElement>()
  const image = useRef<HTMLImageElement>()
  const text_container = useRef<HTMLDivElement>()
  // const container = useRef<HTMLDivElement>()

  useEffect(() => {
    timeline.from(image.current, tweenVars, 0.2)
    timeline.from(text_container.current, tweenVars, 0.4)

    ScrollTrigger.create({
      animation: timeline,
      trigger: wrapper.current,
      start: 'top-=100 80%',
      toggleActions: 'play none none reverse',
    })
  }, [])

  return (
    <section className={styles.wrapper} ref={wrapper}>
      <div className={styles.content}>
        <TitleFlex sectionTitle={sectionTitle} />
        <div className={styles.article_container} ref={text_container}>
          <InterviewContents contentData={contentData} />
        </div>
      </div>
    </section>
  )
}

export default Interview
